import { useCallback, useState } from 'react';
import { Flex, Typography, IconClose, Colors } from '@banhala/ui-kit';
import { localStorageBridge, useAsyncEffect } from 'shared/src/utils';

const STORAGE_KEY = 'SHOULD_SHOW_LIKE_FOLDER_TAB_TOOLTIP';
const TAIL_SIZE = 10;

interface LikeFolderTabTooltipProps {
  anchorCenterX: number;
  anchorBottomY: number;
}

export const LikeFolderTabTooltip = ({
  anchorCenterX,
  anchorBottomY,
}: LikeFolderTabTooltipProps) => {
  const [visible, setVisible] = useState(false);

  useAsyncEffect(async () => {
    const shouldShow = await localStorageBridge.getBoolean(STORAGE_KEY);
    setVisible(shouldShow ?? true);
  }, []);

  const handlePressTooltip = useCallback(() => {
    localStorageBridge.putBoolean(STORAGE_KEY, false);
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <Flex
      position="absolute"
      top={anchorBottomY}
      left={anchorCenterX}
      zIndex={10}
      pointerEvents="box-none"
      alignItems="center"
      transform={[{ translateX: '-50%' }]}
      onPress={handlePressTooltip}
    >
      <Flex
        width={TAIL_SIZE}
        height={TAIL_SIZE}
        backgroundColor="bg_pink_primary"
        transform={[{ rotate: '45deg' }]}
        margin={{ bottom: -TAIL_SIZE / 2 }}
      />
      <Flex.Row
        backgroundColor="bg_pink_primary"
        borderRadius={8}
        padding={{ horizontal: 8, vertical: 6 }}
        alignItems="center"
        gap={8}
      >
        <Typography
          type="body4"
          color="content_always_white"
          numberOfLines={1}
        >
          나만의 감성을 모아보세요
        </Typography>
        <IconClose fill={Colors.content_always_white} size={16} />
      </Flex.Row>
    </Flex>
  );
};
